/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 */

import { createStore } from "satcheljs";
import { ScheduleFiltersStoreSchema } from "./schema/ScheduleFiltersStore";

/**
 * Schedule filters store.
 */
export const ScheduleFiltersStore = createStore<ScheduleFiltersStoreSchema>(
    "scheduleFiltersStore",
    {
        scheduleFilters: undefined
    });